import { AxiosError } from 'axios'


import { useQuery} from '@tanstack/react-query'
import ProjectAPI from '../services/projectAPI'

export default function useSingleProjectCore(singleProjectId: string | null | undefined, handleNetworkErrorFunction:
    | ((error: AxiosError<unknown, any>, SreenContext: string | null) => void)
    | null,
  handleInternErrorFunction:
    | ((errorMessage: string | null, errorCode: number | null) => void)
    | null,) {

        const projectIdFound = singleProjectId || undefined




    const querySingleProject = useQuery({
        queryKey: ['project', singleProjectId],
        queryFn: () => ProjectAPI.getSingleProjectProtectedAPI(singleProjectId || "none"),
        enabled: !!projectIdFound
    })



  return {
        querySingleProject,
        projectIdFound
  }
}
